import { render } from "./not-found-page.vue?vue&type=template&id=3a1ad8fd&scoped=true&ts=true"
import script from "./not-found-page.vue?vue&type=script&lang=ts"
export * from "./not-found-page.vue?vue&type=script&lang=ts"

import "./not-found-page.vue?vue&type=style&index=0&id=3a1ad8fd&scoped=true&lang=css"

import exportComponent from "/github/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1ad8fd"]])

export default __exports__